<template>
  <div class="address-select">
    <div class="select-address">
      <div class="select">
        <div>{{ address.name }} {{ address.phone }}</div>
        <div>
          {{ address.zone && address.zone.name }}
          {{ address.city && address.city.name }}
          {{ address.area && address.area.name }}
          {{ address.town && address.town.name }}
          {{ address.address }}
        </div>
      </div>
      <i class="el-icon-arrow-down" style="cursor: pointer;"></i>

      <el-select
        v-model="value"
        placeholder="请选择"
        @change="handleSelect"
        ref="addressSelect"
      >
        <el-option
          v-for="item in addressList"
          :key="item.id"
          :value="item.id"
          class="option"
        >
          <div class="address-detail">
            <div>{{ item.name }} {{ item.phone }}</div>
            <div>
              {{ item.zone.name }} {{ item.city.name }} {{ item.area.name }}
              {{ item.town && item.town.name }} {{ item.address }}
            </div>
          </div>
          <div
            class="edit"
            @click.stop="
              id = item.id;
              showWriteAddress = true;
              close();
            "
          >
            编辑
          </div>
        </el-option>
        <div
          class="add"
          @click="
            id = null;
            showWriteAddress = true;
            close();
          "
        >
          + 新建地址
        </div>
      </el-select>
    </div>
    <address-edit
      :id="id"
      v-if="showWriteAddress"
      @close="showWriteAddress = false"
      @getAddressList="getAddressList"
    ></address-edit>
  </div>
</template>
<script>
import addressEdit from "@/components/address-edit";
export default {
  props: {
    address: {
      type: Object
    }
  },
  components: {
    addressEdit
  },
  data() {
    return {
      id: null,
      showWriteAddress: false,
      value: "",
      addressList: []
    };
  },
  mounted() {
    this.getAddressList();
  },
  methods: {
    getAddressList() {
      this.$reqGet("api/store/address").then(res => {
        if (res.data.success) {
          this.addressList = res.data.data;
          this.value = null;
        }
      });
    },
    handleSelect(e) {
      this.value = null;
      let address = this.addressList.filter(item => item.id === e)[0];
      this.address.name = address.name;
      this.address.phone = address.phone;
      this.address.zone = address.zone;
      this.address.city = address.city;
      this.address.area = address.area;
      this.address.town = address.town;
      this.address.address = address.address;
    },
    close() {
      this.$refs.addressSelect.blur();
    }
  }
};
</script>
<style lang="less" scoped>
.address-select {
  .select-address {
    width: 360px;
    position: relative;
    border: 1px solid #dcdfe6;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    .select {
      flex: 1;
      > div {
        line-height: normal;
      }
    }
    .el-select {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }
}
.option {
  height: auto;
  line-height: none;
  display: flex;
  align-items: center;
  > .address-detail {
    flex: 1;
  }
  .edit {
    color: #e2333f;
  }
}
.add {
  margin: 10px;
  border: 1px solid #e2333f;
  color: #e2333f;
  height: 30px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/components/address-select.vue